import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SettingsIconButtonComponent } from './settings-icon-button.component';

@NgModule({
    declarations: [SettingsIconButtonComponent],
    exports: [
        SettingsIconButtonComponent
    ],
    imports: [
        CommonModule,
        TooltipModule
    ]
})
export class SettingsIconButtonModule { }
